import {
  useApi,
  type InitiateWorkflowDto,
  type IssueResponseDto,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseInitiateWorkflowParams = {
  code: string;
};

export function useInitiateWorkflow({ code }: UseInitiateWorkflowParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<IssueResponseDto, ExtendedAxiosError, InitiateWorkflowDto>(
    {
      mutationKey: ['actions'],
      mutationFn: (r) =>
        api.issuesApi.initiateWorkflow(code, r).then((r) => r.data),
      onSuccess: async (issue) => {
        queryClient.setQueryData(['issues', code], issue);
        await queryClient.invalidateQueries({
          queryKey: ['user-roles', code],
        });
      },
    },
  );
}
